export class SapIntegration {
  sapVendorId: number = null;
  qaSapVendorId: number = null;
}
